import React, { useState, useCallback } from "react";
import { Spin, notification } from "antd";

import { getAuthorization } from "@arachnys/flow-app/src/api";
import { transformBulkUploadFile, xlsxType } from "@arachnys/flow-app/src/util";
import FileUpload from "@arachnys/styleguide/FileUpload";

const notifyError = () =>
    notification.error({
        message: "File upload error",
        description:
            "Sorry, an unexpected error has occurred on our side, and we are looking into it.",
    });

const AdditionalFileUploader = ({ type, refetchArray, requestId }) => {
    const [files, setFiles] = useState([]);
    const [progress, setProgress] = useState(false);
    const customRequest = useCallback(
        async ({ action, file, onSuccess, onError }) => {
            const formData = new FormData();
            const data = {
                file_type: type,
                file: transformBulkUploadFile(file),
            };

            setProgress(true);
            const auth = await getAuthorization();

            for (const key in data) {
                formData.append(key, data[key]);
            }

            const request = new Request(action, {
                method: "POST",
                headers: {
                    Authorization: auth,
                },
                body: formData,
            });

            const resp = await fetch(request);

            setFiles([]);
            setProgress(false);
            if (resp.ok) {
                onSuccess();
            } else {
                onError();
            }

            return {
                abort: () => {},
            };
        },
        [type]
    );

    return (
        <>
            <FileUpload
                fileList={files}
                hint="Valid file format: .csv, .xlsx"
                accept={`.csv,text/csv,.xlsx,${xlsxType}`}
                action={`/api/tickets/bulk_upload_request/${requestId}/file_upload/`}
                onSuccess={refetchArray[0]}
                onError={notifyError}
                customRequest={customRequest}
                beforeUpload={file => setFiles([file])}
            />
            {progress && <Spin />}
        </>
    );
};

export default AdditionalFileUploader;
